import React from 'react';

export const CloseIconSvg = () => {
    return <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="25.4548" height="2.54548" transform="matrix(0.714275 0.699866 -0.714275 0.699866 1.81836 0.596558)" fill="white"/>
        <rect width="25.4548" height="2.54548" transform="matrix(-0.714275 0.699866 0.714275 0.699866 18.1816 0.596558)" fill="white"/>
    </svg>;
}
